export default "__VITE_ASSET__88dJQ2rTX0iCDc3QQ4neqg__"